import { atom, RecoilState } from "recoil";
import { recoilPersist } from 'recoil-persist';
import { WSPScorecardAtomDto } from "../Component/Model/Dto/WSP/SETAScorecard";

const { persistAtom } = recoilPersist();

export const WSPScorecardAtom: RecoilState<WSPScorecardAtomDto> = atom<WSPScorecardAtomDto>({
    key: 'WSPScorecardAtom',
    default: {
        wspScorecardId: "",
        wspScorecardName: "",
        organisationId: "",
        organisationName: "",
        wspReportPeriodDateFrom: "",
        wspReportPeriodDateTo: "",
        atrReportPeriodDateFrom: "",
        atrReportPeriodDateTo: ""
    } as WSPScorecardAtomDto,
    effects_UNSTABLE : [persistAtom]
});

